// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#1a1a1a","secondaryColor":"#026d8d","ternaryColor":"#ffed00","btnSubmitColor":"#fa5e69","lighterColor":"#fff","danger":"#fa5e69"};